/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-3278
 * ap = alipay, pp = paypal, cc = credit card, null = no previous purchase
 */
export enum LastPaymentOption {
    NONE = '',
    CreditCard = 'cc',
    PayPal = 'pp',
    AliPay = 'ap',
    ApplePay = 'apple',
}